import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
// import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { ApiService } from '../api.service'
import { UserService } from '../user.service'
import moment from 'moment'
import * as fileSaver from 'file-saver';
// import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router'

@Component({
    selector: 'app-reports-pars-individual',
    templateUrl: './reports-pars-individual.component.html',
    styleUrls: ['./reports-pars-individual.component.scss']
})

export class ReportsParsIndividualComponent implements OnInit {
    form: FormGroup;
    isLoaded = true
    isLoading = false
    loadingError = false
    displayHelpMessage = false
    errorMsg = ""
    rptParams: {startDate: string, endDate: string, includeLicense: boolean} = {startDate: null, endDate: null, includeLicense: false}

    reportsDateOptions = {
        format: 'MM/DD/YYYY',
        showClear: true,
        showClose: true,
        showTodayButton: true,
        useCurrent: false,
        allowInputToggle: true,
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar',
            up: 'fa fa-chevron-up',
            down: 'fa fa-chevron-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash',
            close: 'fa fa-times'
            },
        widgetPositioning: {
                horizontal: 'right',
                vertical: 'bottom'
            }
    };

    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private apiService: ApiService,
        private router: Router,
        // private spinner: NgxSpinnerService,
    ) {
        this.prepareForm()
    }

    ngOnInit() {
        // if ( !this.userService.isAdmin ) {
        //     this.userService.deny();
        //     return;
        // }
    }

    prepareForm(){
        this.form = this.fb.group({
            startDate: [null],
            endDate: [null],
            includeLicense: [false],
        });

        this.form.get('startDate').valueChanges.subscribe((value) => {
            if (!moment(value).isValid()) return;
            this.rptParams.startDate = moment(value).format('YYYY-MM-DD');
        });

        this.form.get('endDate').valueChanges.subscribe((value) => {
            if (!moment(value).isValid()) return;
            this.rptParams.endDate = moment(value).format('YYYY-MM-DD');
        });

        this.form.get('includeLicense').valueChanges.subscribe((value) => {
            this.rptParams.includeLicense = value;
        });
        

    }

    pars_individual_report(){
        // validate dates and that starting date is not beyond 2 years.
        let strdt = this.rptParams.startDate
        if (strdt == '' || strdt == null){
            alert('Please select a starting date within the last 2 years.'); return;
        }
        let start_date = new Date(strdt.replace(/-/g, '\/'))
        let todays_date = new Date()
        let endate = this.rptParams.endDate
        let end_date: Date
        if (endate == '' || endate == null){
            end_date = todays_date
            endate = todays_date.getFullYear() + '-' + ('0' + (todays_date.getMonth() + 1)).slice(-2) + '-' + ('0' + todays_date.getDate()).slice(-2) // getMonth gives 0-11 month, then pad with '0' and get last 2 chars with slice.
            this.rptParams.endDate = endate
        }
        else {
            end_date = new Date(endate.replace(/-/g, '\/'))
        }

        let date_diff = Math.floor((Date.UTC(todays_date.getFullYear(), todays_date.getMonth(), todays_date.getDate()) - Date.UTC(start_date.getFullYear(), start_date.getMonth(), start_date.getDate()) ) /(1000 * 60 * 60 * 24));
        if (date_diff > 730) { alert('Please select a starting date within the last 2 years.'); return;}
        if (end_date < start_date) { alert('Please select valid start and end dates within past 2 years.'); return;}

        if ( !confirm(`Are you sure you want to run a PARS Individual report?`) ) return;
        this.isLoading = true
        let data = { }

        // check user's scoped region and provide the ahec ID to run report for.
        if ( !this.userService.isSuperAdmin ) {
            data = { 'ahec_id': this.userService.scopedRegions[0]};
        } else {
            data = { 'ahec_id': '1' };
        }

        data['includeLicense']=this.rptParams.includeLicense;

        // download file
        // show spinner and inactive screen while report is running.
        // this.spinner.show();
        let fileName = 'parsIndividualReport-' + strdt + '_' + endate + '_' + data['ahec_id']
        this.apiService.getParsIndividualReport(data, this.rptParams).subscribe(
            response => {
                this.isLoaded = false
                this.isLoading = true
                const blob = new Blob([response], { type : 'application/vnd.ms.excel' });
                fileSaver.saveAs(blob, fileName + '.xlsx');
                // this.spinner.hide();
                // const file = new File([blob], fileName + '.xlsx', { type: 'application/vnd.ms.excel' });
                // fileSaver.saveAs(file);
                this.isLoaded = true
                this.isLoading = false
            },
            error => {
                // notify error
                this.loadingError = true
                // this.courses = []
                this.isLoaded = true
                this.isLoading = false
                this.errorMsg = error
                console.error(error)
                // this.spinner.hide();
            }
        );
    }

    // go_back(){
    //     this.router.navigate(['/admin/courses-and-events'])
    // }

    get isAuthorized(){
        return this.userService.isAuthorized;
    }

}